import { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';

interface ScheduleRowCardSkeletons {
  length?: number;
}

export const ScheduleRowCardSkeletons: FC<ScheduleRowCardSkeletons> = ({
  length = 4,
}) => {
  return (
    <div className="flex flex-col gap-y-1">
      {[...Array(length)].map((_, index) => {
        return (
          <div key={index} className="py-[18px]">
            <Skeleton height={48} width="100%" />
          </div>
        );
      })}
    </div>
  );
};
